import { DetailText, Tag } from "../units/Text"
import { Table, Body, Head, Row, Th, Td, Paginator, NoDataComponent } from "../Tables/Table"
import { ACBRangedListResponse } from "../Rest/RestAcbList"
import { FC } from "react"
import { formatDate } from '../../helpers/dateFormatter';
import { BoxWrapper } from "../Wrappers/Wrappers";
import { LoadingTableCell } from "../Loading/Loading";
import { OrderController } from "../Tables/Table";
import { ACBRangedListParams } from "../Rest/RestAcbList";
import { selectedDateRangeLabel } from "../Pickers/dataRange";


const tableNoData = 'Нет данных'


interface AcbRangedTableProps {
    data: ACBRangedListResponse | undefined;
    currentPage: number;
    itemsPerPage: number;
    params: ACBRangedListParams;
    setter: (value: number) => void;
    orderSetter: (value: string) => void;
}


export const AcbRangedTable:FC<AcbRangedTableProps> = ({ data, currentPage, itemsPerPage, params, setter, orderSetter }):JSX.Element => {
    return (
        <BoxWrapper p="p0" bg="bg-primary" className="x-scroll relative" r="r15">
            <Table className="table-fixed">
                <Head>
                    <Row>
                        <Th className="align-center table-align-left col-150">
                            <BoxWrapper className="flex align-center space-between" p="p0">
                                Номер АКБ
                                <OrderController 
                                    order={params.ordering} 
                                    value={'serial_number'} 
                                    setter={orderSetter} />
                            </BoxWrapper>
                        </Th>
                        <Th className="align-center table-align-left col-200">
                            <BoxWrapper className="flex align-center space-between" p="p0" style={{paddingRight: "5px"}}>
                                Объект
                                <OrderController 
                                    order={params.ordering} 
                                    value={'building_name'} 
                                    setter={orderSetter} />
                            </BoxWrapper>
                        </Th>
                        <Th className="align-center table-align-left col-200">
                            <BoxWrapper className="flex align-center space-between" p="p0">
                                Вид техники
                                <OrderController 
                                    order={params.ordering} 
                                    value={'client_device_type'} 
                                    setter={orderSetter} />
                            </BoxWrapper>
                        </Th>
                        <Th className="align-center table-align-left col-175">
                            <BoxWrapper className="flex align-center space-between" p="p0">
                                Название
                                <OrderController 
                                    order={params.ordering} 
                                    value={'custom_name'} 
                                    setter={orderSetter} />
                            </BoxWrapper>
                        </Th>
                        <Th className="align-center col-100">
                            <BoxWrapper className="flex align-center space-between" p="p0">
                                Статус
                                <OrderController 
                                    order={params.ordering} 
                                    value={'status'} 
                                    setter={orderSetter} />
                            </BoxWrapper>
                        </Th>
                        <Th className="align-center table-align-right col-150">
                            <BoxWrapper className="flex align-center space-between" p="p0">
                                SOH
                                <OrderController 
                                    order={params.ordering} 
                                    value={'soh'} 
                                    setter={orderSetter} />
                            </BoxWrapper>
                        </Th>
                        <Th className="align-center table-align-right col-175">
                            <BoxWrapper className="flex align-center space-between" p="p0">
                                Эффективность
                                <OrderController 
                                    order={params.ordering} 
                                    value={'energy_ratio'} 
                                    setter={orderSetter} />
                            </BoxWrapper>
                        </Th>
                        <Th className="align-center table-align-right col-150">
                            <BoxWrapper className="flex align-center space-between" p="p0">
                                Циклы
                                <OrderController 
                                    order={params.ordering} 
                                    value={'cycles'} 
                                    setter={orderSetter} />
                            </BoxWrapper>
                        </Th>
                        <Th className="align-center table-align-right col-150">
                            <BoxWrapper className="flex align-center space-between" p="p0">
                                Ресурс
                                <OrderController 
                                    order={params.ordering} 
                                    value={'cycles'} 
                                    setter={orderSetter} />
                            </BoxWrapper>
                        </Th>
                        <Th className="align-center table-align-right col-175">
                            <BoxWrapper className="flex align-center space-between" p="p0">
                                <BoxWrapper className="flex xs-gap align-center" p="p0">
                                    Потребление
                                    <Tag>{selectedDateRangeLabel(params.dateRange.range)}</Tag>
                                </BoxWrapper>
                                <OrderController 
                                    order={params.ordering} 
                                    value={'energy_charge'} 
                                    setter={orderSetter} />
                            </BoxWrapper>
                        </Th>
                        <Th className="align-center table-align-right col-175">
                            <BoxWrapper className="flex align-center space-between" p="p0">
                                <BoxWrapper className="flex xs-gap align-center" p="p0">
                                    Активность
                                    <Tag>{selectedDateRangeLabel(params.dateRange.range)}</Tag>
                                </BoxWrapper>
                                <OrderController 
                                    order={params.ordering} 
                                    value={'activity_ratio'} 
                                    setter={orderSetter} />
                            </BoxWrapper>
                        </Th>
                        <Th className="align-center col-200">
                            <BoxWrapper className="flex align-center space-between" p="p0">
                                Дата онлайн
                                <OrderController 
                                    order={params.ordering} 
                                    value={'online_dt'} 
                                    setter={orderSetter} />
                            </BoxWrapper>
                        </Th>
                    </Row>
                </Head>
                <Body>
                    { data?.results ? (data.results.map((item, index) => (
                        <Row key={index} className="show-up-quick">
                            <Td className="table-align-left">
                                <DetailText className="underline" href={`/react/acb/detail/${item.serial_number}`}>
                                    {item.serial_number}
                                </DetailText>
                            </Td>
                            <Td className="table-align-left">{item.building_name !== null && item.building_name !== "" ? item.building_name: tableNoData}</Td>
                            <Td className="table-align-left">{item.client_device_type !== null && item.client_device_type !== "" ? item.client_device_type : tableNoData }</Td>
                            <Td className="table-align-left">{item.custom_name !== null && item.custom_name !== "" ? item.custom_name : tableNoData }</Td>
                            <Td>{item.error_count === 0 ? '🟢' : '🔴' }</Td>
                            <Td className="table-align-right">{item.soh}%</Td>
                            <Td className="table-align-right">{Math.round(item.energy_ratio)}%</Td>
                            <Td className="table-align-right">{item.cycles}</Td>
                            <Td className="table-align-right">{Math.round(item.cycles / 3000 * 100)}%</Td>
                            <Td className="table-align-right">{ item.energy_charge.toFixed(2) } кВтч</Td>
                            <Td className="table-align-right">{Math.round(item.activity_ratio)}%</Td>
                            <Td>{formatDate(item.online_dt)}</Td>
                        </Row>
                    ))) : (
                        Array.from({ length: itemsPerPage }, (_:any, index:number) => {
                            return (
                                <Row className="" key={index}>
                                    <Td><LoadingTableCell/></Td>
                                    <Td><LoadingTableCell/></Td>
                                    <Td><LoadingTableCell/></Td>
                                    <Td><LoadingTableCell/></Td>
                                    <Td><LoadingTableCell/></Td>
                                    <Td><LoadingTableCell/></Td>
                                    <Td><LoadingTableCell/></Td>
                                    <Td><LoadingTableCell/></Td>
                                    <Td><LoadingTableCell/></Td>
                                    <Td><LoadingTableCell/></Td>
                                    <Td><LoadingTableCell/></Td>
                                </Row>
                            )
                        }) 
                    )
                }
                </Body>
            </Table>
            { data?.results?.length === 0 && <NoDataComponent/> }
            <Paginator
                key={data?.results ? data.results.length + 1 : 0}
                itemsPerPage={itemsPerPage} 
                totalItems={data ? data.count : 1} 
                currentPage={currentPage} 
                setPage={setter}/>
        </BoxWrapper>
    )
}
